(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atcf-email-popup"]) return;
  try {
    
  (function () {
    var KEY = 'atcf_popup_v1';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

    function init() {
      var root = document.querySelector('[data-atcf-popup]');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';

      var box = root.querySelector('.atcf-popup__box');
      var form = root.querySelector('form');
      var design = root.dataset.designMode === 'true';
      var delay = (parseInt(root.dataset.delay, 10) || 30) * 1000;
      var cooldown = (parseInt(root.dataset.cooldown, 10) || 7) * 86400000;
      var returnFocus = null;
      var isBar = false;

      function focusables() {
        return box.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])');
      }
      function open() {
        if (!root.hidden) return;
        isBar = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
        box.setAttribute('aria-modal', isBar ? 'false' : 'true');
        returnFocus = document.activeElement;
        root.hidden = false;
        if (!isBar) {
          var first = box.querySelector('input[type=email]') || box;
          first.focus();
        }
        document.addEventListener('keydown', onKey);
      }
      function close(remember) {
        root.hidden = true;
        document.removeEventListener('keydown', onKey);
        if (remember) { var s = read(); s.dismissed = Date.now(); write(s); }
        if (!isBar && returnFocus && returnFocus.focus) { try { returnFocus.focus(); } catch (e) {} }
      }
      function onKey(e) {
        if (e.key === 'Escape') { close(true); return; }
        if (e.key !== 'Tab' || isBar) return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      root.querySelectorAll('[data-atcf-popup-close]').forEach(function (el) {
        el.addEventListener('click', function () { close(true); });
      });
      if (form) {
        form.addEventListener('submit', function () { var s = read(); s.done = true; write(s); });
      }

      var state = read();
      var justSignedUp = !!root.querySelector('[data-atcf-popup-success]');
      if (justSignedUp) { state.done = true; write(state); open(); return; }
      if (design) { open(); return; }
      if (state.done) return;
      if (state.dismissed && Date.now() - state.dismissed < cooldown) return;

      setTimeout(open, delay);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
